<div ngbDropdown autoClose="outside" (openChange)="onOpenChange($event)" #dropDown="ngbDropdown">
    <div
            tabIndex="0"
            class="form-control"
            [class.show-values]="showValues"
            [class.only-placeholder]="this.checkedCount === 0 && !this.isOpen"
            ngbDropdownAnchor
            [attr.readonly]="disabled ? true : null"
            (click)="toggle($event)">
      <div>
          <ng-container *ngIf="!showPlaceholderValues else placeholderValuesTpl">
            {{selectPlaceholder}}
          </ng-container>
          <ng-template #placeholderValuesTpl>
              <ng-container *ngFor="let item of selectPlaceholder; last as iLast">
                  <ng-container *ngIf="_params.template else defaultPlaceholderValuesTpl"
                                [ngTemplateOutlet]="_params.template"
                                [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
                  <ng-template #defaultPlaceholderValuesTpl>{{item.name}}</ng-template>
                  {{!iLast && ', ' || ''}}
              </ng-container>
          </ng-template>
      </div>
    </div>
    <div class="dropdown-menu" ngbDropdownMenu>
        <div *ngIf="_params.withSearch || _options?.length > 10" class="search-input">
            <cm-search-input (valueDebouncedChange)="onSearch($event)" [minSearchLength]="1"></cm-search-input>
        </div>

        <div *ngIf="_params.noContentConfig && search && !searchedOptions.length" class="no-content">
            <h3 class="title">{{ _params.noContentConfig.title }}</h3>
            <p class="sub-title" *ngIf="_params.noContentConfig.subtitle">{{ _params.noContentConfig.subtitle }}</p>
        </div>
        <div class="checkbox-group">
          <ng-container *ngIf="!_params.noContentConfig || !search || searchedOptions.length">
            <div *ngIf="_params.withSelectAll" class="setting-option">
              <span *ngIf="!valueMap.size" (click)="selectAll()" class="select-all-option">Select all</span>
              <span *ngIf="valueMap.size" (click)="unselectAll()" class="select-all-option">Unselect all</span>
            </div>
            <div *ngIf="!_params.withSelectAll && _params.onlyUnselectAllBtn" class="setting-option">
              <span [class.disabled]="!valueMap.size" (click)="valueMap.size && unselectAll()" class="select-all-option">Clear</span>
            </div>
          </ng-container>
            <div *ngIf="_params.optionDetailColumns?.length" class="detailed-options-header setting-option">
                <span
                    class="detailed-options"
                    [ngStyle]="{width: column.width}"
                    *ngFor="let column of _params.optionDetailColumns">
                    {{column.label}}
                </span>
            </div>
            <cm-checkbox
                    *ngFor="let option of (search ? searchedOptions : _options)"
                    [checked]="valueMap.has(option.id)"
                    (click)="toggleOption(option)"
                    [disabled]="option.disabled"
                    class="checkbox">
                <span *ngIf="!_params.optionDetailColumns?.length">
                    <ng-container *ngIf="_params.template else defaultTpl"
                                  [ngTemplateOutlet]="_params.template"
                                  [ngTemplateOutletContext]="{ $implicit: option }">
                    </ng-container>
                    <ng-template #defaultTpl>{{option.name}}</ng-template>
                </span>
                <span *ngIf="_params.optionDetailColumns?.length" class="detailed-options-wrapper">
                    <span
                        class="detailed-options"
                        [ngStyle]="{width: column.width}"
                        *ngFor="let column of _params.optionDetailColumns">
                        {{option[column.id]}}
                    </span>
                </span>
            </cm-checkbox>
        </div>
    </div>

    <div class="chips-wrapper" *ngIf="_params.withChips">
        <cm-chips
            [disabled]="this.disabled"
            [options]="mapToArray(valueMap, VALUE_TYPE.Object)"
            (removeLabel)="toggleOption($event)"
        ></cm-chips>
    </div>
</div>
